// extracted by mini-css-extract-plugin
export var tamCalculator = "style-module--tam-calculator--ed5f9";
export var tamCalculator__btn = "style-module--tam-calculator__btn--948bc";